import { memo, type FC } from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utils/numberFormat";
import { EngagementSectionPagination } from "src/layouts/Engagements/Overview/Index";

interface CampaignPaginationFooterProps {
  currentPage: number;
  totalPages: number;
  onPrev: () => void;
  onNext: () => void;
}

const CampaignPaginationFooter: FC<CampaignPaginationFooterProps> = ({
  currentPage,
  totalPages,
  onPrev,
  onNext,
}) => {
  const { t, i18n } = useTranslation();
  const pageLabel = t("campaignFlow.shared.pageOf", {
    current: formatNumber(currentPage, {}, i18n.language),
    total: formatNumber(totalPages, {}, i18n.language),
  });

  return (
    <div className="campaign-flow__pagination">
      <span className="campaign-flow__pagination-label">{pageLabel}</span>
      <EngagementSectionPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPrev={onPrev}
        onNext={onNext}
        ariaLabel={pageLabel}
      />
    </div>
  );
};

export default memo(CampaignPaginationFooter);
